module.exports = __webpack_public_path__ + "static/media/test.2a7201bc.wav";